// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"78":"33f8025c","338":"94a0f8a3","456":"8f5813e8","541":"bad78991","544":"15e1f72e","576":"f93594ba","753":"f6c8d94c","775":"399dc740","823":"09d0fc47"}[chunkId] + ".js";
};